







"use strict";

require("./css/common-lib.css");





function setVisibility(value) {
    let body = document.querySelector("body");
    if (body) {
        if (value) {
            body.classList.remove("body-ready-hidden");
        } else {
            body.classList.add("body-ready-hidden");
        }
    }
}











class ReadyHandler {
    





    constructor(options) {
        options = Object.assign({dom: true}, options);
        this.reset();

        if (options.dom) {
            if (typeof $ === "function") {
                this.addState("jquery");
                $(() => {
                    this.changeState("jquery");
                });
            } else {
                this.addState("dom");
                document.addEventListener("DOMContentLoaded", () => {
                    this.changeState("dom");
                });
            }
        }
    }

    _checkDone() {
        if (this._done) {
            throw new Error("already changed to be ready.");
        }
    }

    







    addBeforeVisibleCallback(cb) {
        this._checkDone();
        this._beforeCallbacks.push(cb);
    }

    







    addAfterVisibleCallback(cb) {
        this._checkDone();
        this._afterCallbacks.push(cb);
    }

    







    addState(names, force = false) {
        if (force && this.isDone()) {
            this.reset();
        }
        this._checkDone();
        if (!Array.isArray(names)) {
            names = [names];
        }
        for (let name of names) {
            this._state[name] = false;
        }
    }

    _checkStates() {
        if (Object.values(this._state).every(s => s)) {
            for (let cb of this._beforeCallbacks) {
                cb(); 
            }
            setVisibility(true);
            for (let cb of this._afterCallbacks) {
                cb(); 
            }
            this._done = true;
        } else {
            setVisibility(false);
        }
    }

    






    changeState(name) {
        this._checkDone();
        if (name in this._state) {
            this._state[name] = true;
            this._checkStates();
        }
    }

    isDone() {
        return this._done;
    }

    reset() {
        this._state = {};
        this._done = false;
        this._beforeCallbacks = [];
        this._afterCallbacks = [];
    }
}

module.exports = {
    ReadyHandler,
    defaultReadyHandler: new ReadyHandler()
};
